import { render, staticRenderFns } from "./MateReturnListInfo.vue?vue&type=template&id=e830f350&scoped=true"
import script from "./MateReturnListInfo.vue?vue&type=script&lang=js"
export * from "./MateReturnListInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e830f350",
  null
  
)

export default component.exports